var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreadcrumbs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8991 17.829C34.2719 16.1804 30.6447 14.5318 27.017 12.8825C26.1161 12.4731 25.2021 13.8099 26.0649 14.4043C28.074 15.7877 30.1488 17.0445 32.3019 18.1652C27.2671 18.2685 22.2365 18.4633 17.2096 18.8C11.0747 19.211 9.60078 19.2002 3.20078 20.0002C2.64388 20.1282 2.70852 20.8964 3.29399 20.8901C9.50559 20.8221 11.1633 20.706 17.3731 20.3585C23.1019 20.0377 28.8412 19.8659 34.5793 19.8534C32.9005 21.3614 31.4174 23.0828 30.2852 25.0448C29.7774 25.9243 31.2168 26.8276 31.8078 25.9972C33.616 23.4569 35.5013 21.2567 38.053 19.419C38.6201 19.0116 38.5378 18.1196 37.8991 17.829Z",
    fill: "#FACD6E",
    stroke: "#FACD6E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbs);
export default __webpack_public_path__ + "static/media/breadcrumbs.6f17c1c0c6f99342aff5e37331dce0f5.svg";
export { ForwardRef as ReactComponent };